module.exports = __webpack_public_path__ + "media/components/images/panels/5-b-3cc483d24f21155672a5dae997063d7b.jpeg";